import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import PageHeader from '@common/PageHeader'
import { RouterView } from '@merchant-backend/common-components'
import 'antd4/lib/grid/style/index.css'
import { Tag } from 'hljd'
import { toJS } from 'mobx'
import { inject, observer } from 'mobx-react'
import React, { Component } from 'react'
import { Link } from 'react-router'
import CheckInput from '../../common/CheckInput'
import { formItemLayout } from '../../constants'
import { checkEmoji, validatorCoverPath } from '../../utils'
import isEmpty from 'lodash/isEmpty'
import UploadImage from '../../common/UploadImage'
import UploadVedio from '../../common/UploadVedio'
import MemberSelect from '@common/MemberSelect'
import { isSiYiTeam } from '@util'
const FormItem = Form.Item
const CheckableTag = Tag.CheckableTag

@inject('store')
@observer
class BaseInfo extends Component {
  // onMemberLoaded={setMemberList}
  render() {
    const { id, form, store, property_id } = this.props
    const {
      form_init,
      case_detail,
      checkImg: { checkCMYK },
      tagList,
      changeTagValue,
      setMemberList
    } = store
    const { getFieldDecorator, getFieldValue, getFieldError } = form
    const form_default = toJS(form_init)
    const showVideo = property_id == 11 || property_id == 8

    const header = [
      <Link to="/localMerchant/case">作品管理</Link>,
      id ? '编辑作品' : '发布作品'
    ]
    console.log(tagList)
    return (
      <RouterView
        title="发布作品"
        header={header}
        bodyStyle={{
          padding: '24px 24px 0',
          minHeight: 'calc(100vh - 250px)'
        }}
        titleStyle={{ height: 48, padding: '0 24px' }}
        viewStyle={{ margin: '0 16px 16px 16px' }}
      >
        {/* 案例审核逻辑 */}
        {!!case_detail?.reason &&
          case_detail?.status == 3 && (
            <div style={{ margin: '10px 0 30px 0' }}>
              <PageHeader
                type="error"
                title={`审核未通过原因：${case_detail.reason}`}
                key="coverPathText"
              />
            </div>
          )}
        {/* 视频组件-司仪/摄像 */}
        {showVideo && (
          <FormItem label="上传视频" {...formItemLayout}>
            {getFieldDecorator('setMealDetail', {
              initialValue: form_default.setMealDetail,
              rules: [
                {
                  required: true,
                  message: '请上传视频'
                }
              ]
            })(<UploadVedio />)}
          </FormItem>
        )}
        {/* 图片组件-摄影 */}
        {!showVideo && (
          <FormItem label="图片" {...formItemLayout}>
            {getFieldDecorator('setMealDetail', {
              initialValue: form_default.setMealDetail,
              rules: [
                {
                  required: true,
                  message: '请上传封面图'
                },
                {
                  validator: validatorCoverPath
                }
              ]
            })(<UploadImage checkCMYK={checkCMYK} />)}
          </FormItem>
        )}
        {/* 作品标题 */}
        <FormItem label="标题" {...formItemLayout}>
          {getFieldDecorator('title', {
            initialValue: form_default.title || '',
            rules: [
              {
                required: true,
                message: '请输入标题文字'
              },
              {
                max: 16,
                message: '标题字数不能多于16个字'
              },
              {
                whitespace: true,
                message: '请输入标题文字'
              },
              {
                validator: checkEmoji
              }
            ]
          })(
            <CheckInput
              style={{ width: 440 }}
              placeholder="填写作品标题，必填"
              maxLength={16}
              suffix={`${getFieldValue('title').length}/16`}
              getfielderror={getFieldError}
              type={1}
            />
          )}
        </FormItem>
        {/* 作品标签选择 */}
        {!isEmpty(tagList) && (
          <FormItem className={'tags'} label="标签" {...formItemLayout}>
            {tagList.map((child, i) => {
              return (
                <CheckableTag
                  key={i}
                  checked={child.isActive}
                  onChange={flag => changeTagValue(i, flag)}
                >
                  {child.name}
                </CheckableTag>
              )
            })}
          </FormItem>
        )}
        {/* 司仪商家成员选择 */}
        {isSiYiTeam() && (
          <FormItem label="成员" {...formItemLayout}>
            {getFieldDecorator('emceeMemberId', {
              initialValue: form_default.emceeMemberId,
              rules: [
                {
                  required: true,
                  message: '请选择作品关联成员'
                }
              ]
            })(
              <MemberSelect
                placeholder="请选择"
                style={{ width: 140 }}
                showTeam={false}
                showAll={false}
                onMemberLoaded={setMemberList}
              />
            )}
          </FormItem>
        )}
        {/* MemberSelect */}
      </RouterView>
    )
  }
}

export default BaseInfo
